import createCache from '@emotion/cache'

// TODO: if in ssr
const context = createCache()

export default context
